import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from 'primereact/button';
import { API, DataStore, graphqlOperation } from 'aws-amplify';
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { toast } from "react-toastify";
import { graphQLFindRecordById } from "../../helper/commonfunctions";
import { json } from "react-router";


const ArchiveDialog = (props) => {


  console.log("props", props);

  // const {data} = props;

  const handleArchiveRow = async selectRows => {

    try {

      console.log("selectRows", selectRows);
      selectRows.forEach(async item => {
        let original = await graphQLFindRecordById(props.tableName, item)
        console.log("props.archiveData", props.archiveData);
        let data1 = props.archiveData?.find(row => row.id === item)
		//changes for stipend case only
		if(props.tableName === "getStipendMaster" && props.stipendApprover){
			let original1 = await graphQLFindRecordById("getStipendTransactionCycle", item)
			 original = await graphQLFindRecordById(props.tableName, original1.report_Id)
			console.log("original1", original1);
			data1 = props.archiveData?.find(row => row.reportId === original.id)
			
			console.log("original", original);
			console.log("data1", data1);
		}
		
        //if data1
        if (data1) {
          let data = original.isArchivedUsers ? JSON.parse(original.isArchivedUsers) : null;
      
          //const jsonData = original.isArchivedUsers && data ? { ...data, ...JSON.parse(props.jsonData) } : props.jsonData 
          const objPush = [{"userId": props.loggedUserId,"archiveDesignation":  data1.archiveDesignation  }]
          // let jsonData = original.isArchivedUsers && data ? { ...data, ...objPush } : objPush
          let jsonData=[];
          if(data){
            jsonData=[...data,...objPush];
          }else{
            jsonData=objPush;
          }

          console.log("props.archiveData jsonData0", jsonData);

          //stringify
            jsonData = JSON.stringify(jsonData)
          console.log("props.archiveData jsonData", jsonData);
          //format desig:loggeduser
          await API.graphql(
            graphqlOperation(props.mutations, {
              input: {
                id: original?.id,
                isArchived: "True",
                isArchivedUsers: jsonData,
                _version: original?._version
              }
            })
          );
          }
          
        });

      // toast.success('Request Archive Successfully.');
      toast.success('Selected forms moved to Archive.');
      props.setIsLoadData();
      props.getMasterData();
     

    } catch (err) {
    console.log("Error is Delete :-", err);
  }
};




const footerContentForArchiveForm = () => (
  <div className="text-center">
    <>
      <button
        className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-white text-[14px] xl:text-[0.729vw] font-medium bg-[#113699] border border-[#EFF8FF] rounded-md"
        onClick={() => {
          handleArchiveRow(props.selectedRows);
          props.setArchiveVisible(false);
          props.setIsPanelOpen(false);
        }}
      >
        Yes
      </button>
      <button
        onClick={() => {
          props.setArchiveVisible(false);
          props.setIsPanelOpen(false);
          props.setSelectedRows([]);
        }}
        type="button"
        className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md"
        id="add-family-cancel-btn"
      >
        No
      </button>

    </>
  </div>
);



return (
  <>
    <Dialog
      header=""
      visible={props.archiveVisible}
      style={{ width: "30vw" }}
      //                      closable={false}
      onHide={() => {
        props.setArchiveVisible(false);
        props.setIsPanelOpen(false);
        props.setSelectedRows([]);
      }}
      footer={footerContentForArchiveForm}
    >
      <div className="m-0">
        <div className="font-medium text-[18px] text-[#249144]">
          The selected forms will be moved to the Archive folder. Are you sure you want to proceed?
        </div>
      </div>
    </Dialog>
  </>
)

}

export default ArchiveDialog
